import MoonLoader from "react-spinners/MoonLoader"

function Spinner({ type }) {
  return (
    <div
      className={`${
        type === "child"
          ? "h-[calc(100vh-116px)]"
          : type === "academy"
          ? "h-[calc(100vh-350px)] lg:h-80"
          : "h-screen"
      } flex items-center justify-center`}
    >
      <MoonLoader color="#485AFF" />
    </div>
  )
}
export default Spinner
